import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined';
import DeleteSweepOutlinedIcon from '@mui/icons-material/DeleteSweepOutlined';

const LathropDrmMenus = [
    {
        label: 'sidebar.menu.drm',
        type: "section",
        children: [
            {
                uri: "/drm/audit-result",
                label: 'sidebar.menuItem.audit-result',
                type: "nav-item",
                icon: <DescriptionOutlinedIcon sx={{fontSize: 20}}/>
            },
            {
              
                label: 'sidebar.menuItem.file-upload',
                type: "nav-item",
                icon: <FileUploadOutlinedIcon sx={{fontSize: 20}}/>
            },
            {
                label: 'sidebar.menuItem.upload-status',
                type: "nav-item",
                icon: <PendingOutlinedIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/drm/archive",
                label: 'sidebar.menuItem.archive',
                type: "nav-item",
                icon: <DeleteSweepOutlinedIcon sx={{fontSize: 20}}/>
            },
        ]
    },
   
];

export default LathropDrmMenus;